exports.f = {}.propertyIsEnumerable;

